import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateUserEmployerBusinessIdProjectBusinessIdResources } from 'store/userProfile/services/update-user-employer-business-id-project-business-id-resources.service';
import { selectSelectedProjectId, selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

export const setUpdateUserEmployerBusinessIdProjectBusinessIdResources = createAsyncThunk(
  'users/setUpdateUserEmployerBusinessIdProjectBusinessIdResources',
  async (params, { getState }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(state);

    const _params = {
      ...params,
      projectId: selectedProjectId
    }

    const updatedResource = await updateUserEmployerBusinessIdProjectBusinessIdResources(_params);

    return updatedResource;
  }
);